<template>
  <b-row id="medic-assistance-prof" class="section-invert ">
    <b-col md="12" lg="6" class="nopadding" order-lg="2">
      <div class="col-bg ml-lg-auto"></div>
    </b-col>
    <b-col md="12" lg="6" class="content my-auto title">
        <h3 v-html="$t('title')"></h3>
      <div class="subtitle">
        <div class="subtitle-list subtitle-list mt-sm-5">
          <div>
            <p>
              <v-icon large v-text="'mdi-human-female-boy'"></v-icon
              >{{ $t("general") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-baby-carriage'"></v-icon
              >{{ $t("pediatrics") }}
            </p>
          </div>
          <div class="logorec">
              <img class="vertical w-25" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png" width="150px"/>
              <base-button white class="btn1 mt-5"
              @click="getOpensaludpass()">
              {{ button_text }}
            </base-button>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import es from '@/lang/es/public/views/primesalud-medical-assistance.json'
  import en from '@/lang/en/public/views/primesalud-medical-assistance.json'
  import opensaludprimeMixin from '@/mixins/opensaludprime.mixin'

  export default {
    mixins: [opensaludprimeMixin],
    i18n: {
      messages: {
        es,
        en,
        mx: es
      }
    },
    props: {
      button_text: {
        type: String,
        default () {
          return this.$t('hire-now-with-price')
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../static-appopensalud/css/public/layout.scss";
  #medic-assistance-prof .col-bg {
    background-image: url(/static-appopensalud/img/bgs/medical-assistance-professionals.png),
      linear-gradient(273deg, #ffffff96, transparent);
    background-position: center;
    background-blend-mode: overlay;

  }
.nopadding{
    padding: 0px !important;
  }
    .reverse-sm {
  @include media(mobile, tablets) {
    flex-direction: column-reverse;
  }
  }

  .title h3{
        font-size: 3em;
    }
    .logorec{
        padding-top: 2em;
        text-align: center;
    }
  @media (max-width: 1268px) {
    #medic-assistance
      > div.content.my-auto.col-md-12.col-lg-6
      > div
      > div
      > div
      > p {
      font-size: 1rem;
    }

  }

  @media (max-width: 600px) {

  .title h3{
        font-size: 1.75rem !important;
    }

    .subtitle p{
      font-size: 1rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/MedicalAssistanceLandingProfessionals.vue